export const REPORT_TEMPLATES_TEXTS = {
  // Table columns
  COLUMN_TEMPLATE_NAME: 'Template Name',
  COLUMN_TABLE_NAMES: 'Table Names',
  COLUMN_DATE_CREATED: 'Date Created',
  COLUMN_CREATED_BY: 'Created By',
  COLUMN_ACTIVE: 'Active',
  COLUMN_ACTIONS: 'Actions',

  // Empty state
  NO_TEMPLATES_YET: 'No templates yet',
  CREATE_YOUR_FIRST_REPORT: 'Create your first report template to get started',

  // Buttons & actions
  ADD_NEW: 'ADD NEW',
  EDIT: 'Edit',
  CREATE_TEMPLATE: 'Create Template',
  SAVE_CHANGES: 'Save Changes',
  REMOVE_FILE: 'Remove file',

  // Dialog titles
  CREATE_DIALOG_TITLE: 'Create a New Report Template',
  EDIT_DIALOG_TITLE: 'Edit Report Template',

  // Form labels
  TEMPLATE_NAME_LABEL: 'Template Name',
  SHEET_TEMPLATE_NAME_LABEL: 'Template Name for this Sheet',
  SELF_SERVICE_TABLE_LABEL: 'Self Service Table',
  SELECT_TABLE_PLACEHOLDER: 'Select a table...',
  SELECT_TABLE_INSTRUCTION: 'Select a table from the self service reporting collection',

  // Validation messages
  VALIDATION_TOAST_TITLE: 'Please fix the following errors:',
  TEMPLATE_NAME_REQUIRED: 'Template name is required',
  DISPLAY_NAME_REQUIRED: 'Display name is required',
  AT_LEAST_ONE_SHEET_REQUIRED: 'At least one sheet must have a self service table selected',

  // Sheet configuration
  SHEET_PREFIX: 'Sheet:',
  EXTRACTED_VARIABLES: 'Extracted Variables',
  VALIDATING_VARIABLES: 'Validating variables...',
  NO_TEMPLATE_VARIABLES: 'No template variables ({{...}}) found in this sheet',
  AVAILABLE_COLUMNS: 'Available columns',
  AVAILABLE_COLUMNS_HINT: 'Click a column to copy its token',
  COPY_TOKEN_SUCCESS: 'Token copied to clipboard',
  COPY_TOKEN_ERROR: 'Failed to copy token',

  // Upload step
  FILE_TYPE_ERROR: 'Only .xlsx and .xlsm files are supported',
  UPLOAD_INSTRUCTION:
    'Use {{column name}} placeholders in your Excel file to define where data should appear. These must match the column names in your selected Self Service Table—unmatched variables will be left empty.',

  // Fallbacks
  UNKNOWN: 'Unknown',
  TABLE_FALLBACK_PREFIX: 'Table',
} as const;

// Helper functions for dynamic text
export const getTemplateCountText = (count: number): string => {
  return `${count} Template${count !== 1 ? 's' : ''}`;
};

export const getSheetCountText = (count: number): string => {
  return `${count} sheet${count !== 1 ? 's' : ''}`;
};

export const getSheetsDetectedText = (count: number): string => {
  return `(${count} sheet${count !== 1 ? 's' : ''} detected)`;
};

export const getUnmatchedVariablesWarning = (count: number, variables: string[]): string => {
  return `${count} variable(s) do not match Self Service table columns: ${variables.join(', ')}`;
};

export const getAllVariablesMatchedText = (count: number): string => {
  return `All ${count} variable(s) match Self Service table columns`;
};

export const getTableFallbackName = (questionId: number): string => {
  return `${REPORT_TEMPLATES_TEXTS.TABLE_FALLBACK_PREFIX} ${questionId}`;
};
